import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function SectionTemplatesIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="7.33"
        y="1.33"
        width="7.33"
        height="7.33"
        rx="1.6"
        strokeDasharray="1.4 1.4"
        fill="none"
      />
      <rect
        x="4.33"
        y="4.33"
        width="7.33"
        height="7.33"
        rx="1.6"
        strokeDasharray="1.4 1.4"
        fill="var(--surface-2, white)"
      />
      <rect
        x="1.33"
        y="7.33"
        width="7.33"
        height="7.33"
        rx="1.6"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
